import React, { useState, useEffect } from 'react';
import dateFnsFormat from 'date-fns/format';
import dateFnsParse from 'date-fns/parse';
import compareAsc from 'date-fns/compareAsc';
import parseISO from 'date-fns/parseISO';
import ConfirmedBookingRoom from './ConfirmedBookingRoom.js';
import PolicyText from './PolicyText.js';

export default function Completed(props) {

    const [confirmedReservation, setConfirmedReservation] = useState();
    const [loading, setLoading] = useState(true);
    const [hasSingleCancellationPolicy, setHasSingleCancellationPolicy] = useState();
    const [hasSingleDepositPolicy, setHasSingleDepositPolicy] = useState();

    useEffect(() => {
        

        

        let url = 'api/reservations/' + props.reservationId;

        fetch(url)
            .then((response) => {
                return response.json();
            })
            .then(data => {
                var data2 = data;
                setHasSingleDepositPolicy(data.bookingRooms.filter(x => x.depositPolicy.id === data.bookingRooms[0].depositPolicy.id).length === data.bookingRooms.length);
                setHasSingleCancellationPolicy(data.bookingRooms.filter(x => x.cancellationPolicy.id === data.bookingRooms[0].cancellationPolicy.id).length === data.bookingRooms.length);
                setConfirmedReservation(data);
                setLoading(false);
               
            }).catch(error => {
                console.log(error);
            });

        

    }
        , []);

    useEffect(() => {
        // Google Ads conversion tracking script
        const script = document.createElement('script');
        script.innerHTML = `
          gtag('event', 'conversion', {
              'send_to': 'AW-16705537322/3DGZCMDTgNUZEKqK6Z0-',
              'value': ${confirmedReservation?.charge??'125.00'},
              'currency': 'GBP',
              'transaction_id': ${confirmedReservation?.id??'UNKNOWN'}
          });
        `;
        document.body.appendChild(script);
    }, [confirmedReservation]);



    function payNow(bookingRooms) {
        
        var total = 0;
        for (var i = 0; i < bookingRooms.length; i++) {
            for (var j = 0; j < bookingRooms[i].paymentSchedules.length; j++) {
                if (compareAsc(parseISO(bookingRooms[i].paymentSchedules[j].due), new Date()) < 1) {
                    total += bookingRooms[i].paymentSchedules[j].amount;
                }
            }

        }
        return total;
    }

    
    return (
        <div>

            {confirmedReservation && hasSingleCancellationPolicy != null && hasSingleDepositPolicy != null &&
            <>
                <p>Thank you {confirmedReservation.guest.firstName}, Your booking at {confirmedReservation.bookingMaster.property.name} is confirmed.</p>

                <div className='summary-container'>
                
                    <div className={'summary-dates'}>
                        <div className='row'>
                            <div className='col-4'><small>Checkin:</small></div>
                            <div className='col-8 text-right'><small>{dateFnsFormat(parseISO(confirmedReservation.arrive), 'eee d MMM yyyy')}</small></div>
                        </div>
                        <div className='row'>
                            <div className='col-4'><small>Checkout:</small></div>
                            <div className='col-8 text-right'><small>{dateFnsFormat(parseISO(confirmedReservation.checkOutDate), 'eee d MMM yyyy')}</small></div>

                        </div>
                    
                        <div className='row'>
                            <div className='col-6 text-right'><small>{confirmedReservation.nights} nights stay</small></div>
                        
                        </div>
                    
                    
                        <hr/>
                    </div>

                        
                    <div>
                        {
                        confirmedReservation.bookingRooms.map((bookingRoom) =>

                            <ConfirmedBookingRoom
                                key={bookingRoom.id}
                                bookingRoom={bookingRoom}
                                showCancellationPolicy={!hasSingleCancellationPolicy}
                                showDepositPolicy={!hasSingleDepositPolicy}

                            />)
                            }                  
                    </div>
                        
                    <div>

                        <div className='row'>
                            <div className='col-6'><strong>Total</strong></div>
                            <div className='col-6 text-right'><strong>£{(+confirmedReservation.charge).toFixed(2)}</strong></div>
                        </div>
                        <div className='row'>
                            <div className='col-6'><strong>Pay Now</strong></div>
                            <div className='col-6 text-right'><strong>£{(+payNow(confirmedReservation.bookingRooms)).toFixed(2)}</strong></div>
                        </div>
                    </div>

                    {
                        (confirmedReservation.bookingRooms.length === 1 || hasSingleCancellationPolicy) &&

                        
                        <div>
                            <PolicyText
                                policy={confirmedReservation.bookingRooms[0].cancellationPolicy}
                            />
                                
                        </div>
                    }
                    {
                        (confirmedReservation.bookingRooms.length === 1 || hasSingleDepositPolicy) &&

                            <div>
                            <PolicyText
                                policy={confirmedReservation.bookingRooms[0].depositPolicy}
                            />

                            </div>
                        
                    }


                </div>
                <div>
                    {
                        confirmedReservation.bookingMaster.property.policies.map((policy) =>

                            <div>
                                <PolicyText
                                    policy={policy}
                                />
                            </div>

                        )
                    }
                </div>
            </>
        }


        </div>);

    
}